import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import brandModalActions from './brandCopyModal/actions';
import { tableConfig } from '../../../../settings/index';
import Api, { executeAction } from '../../../../helpers/api';
import { sendRequest } from '../../../../helpers/saga';
import { logger } from '../../../../helpers/logger';
import notifications from '../../../../redux/notifications/actions';
import { t } from '../../../../i18n';

const api = new Api('districts');
const formInfoApi = new Api('districts/form_data');

function* loadData({ payload }) {
  try {
    const {
      page = 1,
      pageSize = tableConfig.pageSize,
      column,
      order,
      filter = '',
      states = [],
      positions = [],
    } = payload;

    const result = yield call(
      sendRequest,
      api.load,
      { search: { page, pageSize, column, order, filter, states, positions } },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data && result.data.success && result.data.success.data) {
      const { records, totalCount, filteredCount, sortableColumns, filters } = result.data.success.data;

      yield put(
        actions.loadDataSuccess({
          data: records,
          filters,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* processAction({ payload }) {
  try {
    const { method, url, data, params, cb } = payload;

    const result = yield call(sendRequest, executeAction, { url, method, data, params }, notifications.REQUEST_ERROR);

    if (result) {
      yield put(actions.onProcessActionSuccess());
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.admin.districts.make_copy_for_brand_success_message'),
        }),
      );
      yield put(brandModalActions.closeMakeCopyForBrandModal());

      if (cb) {
        cb();
      }
    } else {
      yield put(actions.onProcessActionFailure());
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadFormData() {
  try {
    const { formInfo } = yield all({
      formInfo: call(sendRequest, formInfoApi.load, {}, notifications.REQUEST_ERROR),
    });

    if (formInfo) {
      yield put(
        actions.loadFormDataSuccess({
          formInfo: formInfo && formInfo.data && formInfo.data.success && formInfo.data.success.data,
        }),
      );
    } else {
      logger.error('Error: form data is undefined...');
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData)]);
  yield all([takeEvery(actions.LOAD_FORM_DATA, loadFormData)]);
  yield all([takeEvery(actions.PROCESS_ACTION, processAction)]);
}
